import Box from '@mui/material/Box';
import {keyframes, useTheme} from '@mui/material/styles';

const pcAssemble = keyframes`
  0%        { opacity:0; transform:scale(.2) rotate(-20deg); }
  14%       { opacity:1; transform:scale(1) rotate(0); }
  78%       { opacity:1; transform:scale(1) rotate(0); }
  92%, 100% { opacity:0; transform:scale(.2) rotate(20deg); }
`;

const ARROWS = [
  {
    delay: '0.6s',
    d: 'M18.62,43.16l2,3.46,5.52-3.18-1.31,7.44,3.94.69,1.31-7.44,4.1,4.88,3.05-2.57-7.12-8.49c-.47-.56-1.27-.7-1.9-.33l-9.58,5.54Z',
  },
  {
    delay: '0.12s',
    d: 'M21.92,24.45l2,3.46,5.52-3.18-1.31,7.44,3.94.69,1.31-7.44,4.1,4.88,3.05-2.57-7.12-8.49c-.47-.56-1.27-.7-1.9-.33l-9.58,5.54Z',
  },
  {
    delay: '0.36s',
    d: 'M53.39,30.09l-3.46,2,3.18,5.52-7.44-1.31-.69,3.94,7.44,1.31-4.88,4.1,2.57,3.05,8.49-7.12c.56-.47.7-1.27.33-1.9l-5.54-9.58Z',
  },
  {
    delay: '0.0s',
    d: 'M25.22,5.74l2,3.46,5.52-3.18-1.31,7.44,3.94.69,1.31-7.44,4.1,4.88,3.05-2.57L36.7.54c-.47-.56-1.27-.7-1.9-.33l-9.58,5.54Z',
  },
  {
    delay: '0.96s',
    d: 'M9.02,22.26l2.57,3.06-4.88,4.1,7.44,1.31-.69,3.94-7.44-1.31,3.18,5.52-3.46,1.99L.2,31.27c-.36-.63-.22-1.43.34-1.9l8.48-7.11Z',
  },
  {
    delay: '1.08s',
    d: 'M24.87,8.73l-.35,3.98-6.34-.55,4.34,6.19-3.28,2.29-4.34-6.19-1.65,6.15-3.85-1.04,2.87-10.7c.19-.7.85-1.17,1.58-1.11l11.03.97Z',
  },
  {
    delay: '0.24s',
    d: 'M43.13,11.95l-1.03,3.86,6.15,1.65-6.19,4.34,2.29,3.28,6.19-4.34-.55,6.34,3.98.34.97-11.03c.06-.73-.4-1.39-1.11-1.58l-10.69-2.86Z',
  },
  {
    delay: '0.84s',
    d: 'M16,59l1.03-3.86-6.15-1.65,6.19-4.34-2.29-3.28-6.19,4.34.55-6.34-3.98-.34-.97,11.03c-.06.73.4,1.39,1.11,1.58l10.69,2.86Z',
  },
  {
    delay: '0.48s',
    d: 'M34.27,62.22l.35-3.98,6.34.55-4.34-6.19,3.28-2.29,4.34,6.19,1.65-6.15,3.85,1.04-2.87,10.7c-.19.7-.85,1.17-1.58,1.11l-11.03-.97Z',
  },
];

const DOT = {delay: '0.72s', cx: 25.14, cy: 60.59, r: 3.5};

const arrowStyles = (delay: string, ink: string) => ({
  fill: ink,
  opacity: 0,
  transformBox: 'fill-box',
  transformOrigin: 'center',
  animation: `${pcAssemble} 2.6s ease-in-out infinite`,
  animationDelay: delay,
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
    opacity: 1,
  },
});

function AnimatedPineconeLogo() {
  const theme = useTheme();
  const ink = theme.palette.text.primary;

  return (
    <Box
      component="svg"
      viewBox="0 0 59.13 64.09"
      width={32}
      height={35}
      role="status"
      aria-label="Loading"
    >
      {ARROWS.map(({delay, d}) => (
        <Box key={d} component="path" d={d} sx={arrowStyles(delay, ink)} />
      ))}
      <Box component="circle" cx={DOT.cx} cy={DOT.cy} r={DOT.r} sx={arrowStyles(DOT.delay, ink)} />
    </Box>
  );
}

export default AnimatedPineconeLogo;
